var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import TaskService from "../../../services/TaskService";
import FromTo from "./FromTo";
import { TaskStatuses, } from "../../shared/domainTypes/task/task.type";
import DeprecatedSelect from "../../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import ErrorService from "../../../src/Services/Shared/Error.service";
import { getXSRF } from "../../../src/Services/Shared/FetchService";
const getReassignButtonLabel = (label, loading, num) => (_jsxs(Fragment, { children: [" ", loading ? _jsx("span", { className: "fa fa-circle-notch fa-spin" }) : num, " ", label, num !== 1 ? "s" : ""] }));
export default class ReassignTasks extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.fetchPeopleThatCanBeAssigned = (search) => {
            const maxPeople = 10;
            return TaskService.getAssignedPeople(search, maxPeople);
        };
        this.fetchPeopleAssignedToTasks = (search) => {
            const maxPeople = 10;
            return TaskService.getPeopleAssignedToTasks(search, maxPeople);
        };
        this.fetchPeopleAssignedToTemplates = (search) => {
            const maxPeople = 10;
            return TaskService.getPeopleAssignedToTemplates(search, maxPeople);
        };
        this.resetTaskErrorAndSuccess = () => this.setState({ reassignTaskSuccess: false, reassignTaskError: null });
        this.resetTemplateErrorAndSuccess = () => this.setState({
            reassignTemplateSuccess: false,
            reassignTemplateError: null,
        });
        this.handleTaskFromChange = (person) => {
            this.setState({ taskFromPerson: person }, this.reloadAffectedTasks);
            this.resetTaskErrorAndSuccess();
        };
        this.reloadAffectedTasks = () => {
            if (this.state.taskFromPerson) {
                TaskService.getTasksAssignedToPerson(this.state.taskFromPerson.personId, this.state.taskStatuses.map((status) => status.id)).then((tasks) => this.setState({ tasksAffected: tasks, tasksAffectedLoading: false }));
                this.setState({ tasksAffectedLoading: true });
            }
        };
        this.reloadAffectedTemplates = () => {
            if (this.state.templateFromPerson) {
                TaskService.getTemplatesAssignedToPerson(this.state.templateFromPerson.personId, this.state.templateIncludeActionPlan).then((templates) => this.setState({
                    templatesAffected: templates,
                    templatesAffectedLoading: false,
                }));
                this.setState({ templatesAffectedLoading: true });
            }
        };
        this.handleTemplateFromChange = (person) => {
            this.setState({ templateFromPerson: person }, this.reloadAffectedTemplates);
            this.resetTemplateErrorAndSuccess();
        };
        this.handleTaskSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            this.resetTaskErrorAndSuccess();
            this.setState({ reassigningTasks: true });
            const response = yield fetch("/aviso/taskAdmin/reassignTasks", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    fromPersonId: this.state.taskFromPerson.personId,
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    toPersonId: this.state.taskToPerson.personId,
                    taskStatusIds: this.state.taskStatuses.map((status) => status.id),
                }),
            });
            let data;
            try {
                data = yield response.json();
                if (data.success) {
                    this.setState({ reassignTaskSuccess: true });
                    this.reloadAffectedTasks();
                }
                else {
                    this.setState({ reassignTaskError: data.message ? data.message : "" });
                }
            }
            catch (error) {
                this.setState({
                    reassignTaskError: ErrorService.getMessageFromError(error),
                });
            }
            this.setState({ reassigningTasks: false });
        });
        this.handleTemplateSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            this.resetTemplateErrorAndSuccess();
            this.setState({ reassigningTemplates: true });
            const response = yield fetch("/aviso/taskAdmin/reassignTaskTemplates", {
                method: "POST",
                credentials: "include",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    fromPersonId: this.state.templateFromPerson.personId,
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    toPersonId: this.state.templateToPerson.personId,
                    includeTempsInActionPlans: this.state.templateIncludeActionPlan,
                }),
            });
            let data;
            try {
                data = yield response.json();
                if (data.success) {
                    this.setState({ reassignTemplateSuccess: true });
                    this.reloadAffectedTemplates();
                }
                else {
                    this.setState({
                        reassignTemplateError: data.message ? data.message : "",
                    });
                }
            }
            catch (error) {
                this.setState({
                    reassignTemplateError: ErrorService.getMessageFromError(error),
                });
            }
            this.setState({ reassigningTemplates: false });
        });
        this.state = {
            taskFromPerson: null,
            taskToPerson: null,
            taskStatuses: [TaskStatuses.notStarted, TaskStatuses.inProgress],
            tasksAffected: [],
            tasksAffectedLoading: false,
            templatesAffectedLoading: false,
            templateFromPerson: null,
            templateToPerson: null,
            templateIncludeActionPlan: true,
            templatesAffected: [],
            reassignTaskSuccess: false,
            reassignTemplateSuccess: false,
            reassignTaskError: null,
            reassignTemplateError: null,
            reassigningTasks: false,
            reassigningTemplates: false,
        };
    }
    render() {
        return (_jsx(Fragment, { children: _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsx("h1", { className: "title", children: "Bulk Reassign" }) }) }), _jsxs("div", { className: "card card-body mb-3", role: "main", children: [_jsx("h4", { children: "Tasks" }), _jsx("p", { className: "text-muted", children: "Reassign all tasks from the given person to a new person." }), _jsxs("form", { onSubmit: this.handleTaskSubmit, children: [_jsx("div", { className: "form-group", children: _jsx(FromTo, { loadFromOptions: this.fetchPeopleAssignedToTasks, loadToOptions: this.fetchPeopleThatCanBeAssigned, fromPerson: this.state.taskFromPerson, toPerson: this.state.taskToPerson, onFromChange: this.handleTaskFromChange, onToChange: (person) => {
                                                this.setState({ taskToPerson: person });
                                                this.resetTaskErrorAndSuccess();
                                            } }) }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "statuses", children: "Statuses" }), _jsx(DeprecatedSelect, { id: "statuses", "aria-label": "Statuses", value: this.state.taskStatuses.map((status) => ({
                                                    label: status.label,
                                                    value: status,
                                                })), options: Object.values(TaskStatuses).map((taskStatuses) => ({
                                                    value: taskStatuses,
                                                    label: taskStatuses.label,
                                                })), onChange: (statuses) => {
                                                    this.resetTaskErrorAndSuccess();
                                                    this.setState(
                                                    // @ts-expect-error - TS7006 - Parameter 'status' implicitly has an 'any' type.
                                                    { taskStatuses: statuses.map((status) => status.value) }, this.reloadAffectedTasks);
                                                }, clearable: false, multi: true, placeholder: "All Statuses" }), _jsx("div", { children: _jsx("small", { className: "form-text text-muted", children: "Reassign all tasks with these statuses" }) })] }), _jsx("div", { className: "form-group", children: _jsxs("button", { type: "submit", className: "btn btn-primary", disabled: !(this.state.taskFromPerson && this.state.taskToPerson) ||
                                                this.state.reassigningTasks, children: ["Reassign", this.state.reassigningTasks ? "ing" : "", this.state.taskFromPerson &&
                                                    getReassignButtonLabel("Task", this.state.tasksAffectedLoading, this.state.tasksAffected.length)] }) })] }), this.state.reassignTaskSuccess && (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { className: "fa fa-check", "aria-hidden": true }), " Tasks Reassigned"] })), this.state.reassignTaskError !== null && (_jsxs("div", { className: "alert alert-danger", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": true }), " ", "Error: " +
                                        (this.state.reassignTaskError
                                            ? this.state.reassignTaskError
                                            : "Unknown Error")] }))] }), _jsxs("div", { className: "card card-body", role: "main", children: [_jsx("h4", { children: "Task Templates" }), _jsx("p", { className: "text-muted", children: "Update task templates to default to a new person. This will only affect tasks created from templates in the future; tasks that have already been created will not be affected." }), _jsxs("form", { onSubmit: this.handleTemplateSubmit, children: [_jsx("div", { className: "form-group", children: _jsx(FromTo, { loadFromOptions: this.fetchPeopleAssignedToTemplates, loadToOptions: this.fetchPeopleThatCanBeAssigned, fromPerson: this.state.templateFromPerson, toPerson: this.state.templateToPerson, onFromChange: this.handleTemplateFromChange, onToChange: (person) => {
                                                this.setState({ templateToPerson: person });
                                                this.resetTemplateErrorAndSuccess();
                                            } }) }), _jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { id: "includeInActionPlan", type: "checkbox", className: "custom-control-input", checked: this.state.templateIncludeActionPlan, onChange: (event) => {
                                                            this.resetTemplateErrorAndSuccess();
                                                            this.setState({ templateIncludeActionPlan: event.target.checked }, this.reloadAffectedTemplates);
                                                        } }), _jsxs("label", { htmlFor: "includeInActionPlan", className: "custom-control-label", children: ["Reassign Task Templates used in Action Plan Templates", " "] })] }), _jsx("small", { className: "form-text text-muted", children: "This will only affect new Action Plans. Action Plans that have already been created will not be affected." })] }), _jsx("div", { className: "form-group", children: _jsxs("button", { type: "submit", className: "btn btn-primary", disabled: !(this.state.templateFromPerson &&
                                                this.state.templateToPerson) || this.state.reassigningTemplates, children: ["Reassign", this.state.reassigningTemplates ? "ing" : "", this.state.templateFromPerson &&
                                                    getReassignButtonLabel("Template", this.state.templatesAffectedLoading, this.state.templatesAffected.length)] }) })] }), this.state.reassignTemplateSuccess && (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { className: "fa fa-check", "aria-hidden": true }), " Templates Reassigned"] })), this.state.reassignTemplateError !== null && (_jsxs("div", { className: "alert alert-danger", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": true }), " ", "Error: " +
                                        (this.state.reassignTaskError
                                            ? this.state.reassignTaskError
                                            : "Unknown Error")] }))] })] }) }));
    }
}
